var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "template-default vertical-layout" }, [
    _c("div", { staticClass: "top fixed-top" }, [
      _c("div", { class: _vm.isMobile ? "" : "container" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", [_c("Logo", { staticClass: "pt-1" })], 1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "position-relative" },
            [
              _c("ArrowBreadcrumbs", {
                attrs: { title: _vm.titleToShow },
                on: { open: _vm.onOpen }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("main", [
        _c("div", { staticClass: "d-flex justify-content-around pt-4" }, [
          _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar" }, [_vm._t("sidebar")], 2)
        ])
      ])
    ]),
    _vm._v(" "),
    _c("footer", [_c("Footer"), _vm._v(" "), _vm._t("footer")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3593bc4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3593bc4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/DefaultLayout.vue
// module id = null
// module chunks = 